import React from 'react';
import classnames from 'classnames';
import { noop, map, get, fromPairs, isEqual } from 'lodash';

// local dependencies
import { button as Button } from 'modules/button';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';
import { Form } from 'modules/form';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { cSrOrderListNotes as CSrOrderListNotes } from 'ui/views/widgets/cSROrderListNotes';
 *
 * // render
 * <CSrOrderListNotes propName='propValue'/>
 */

 /******************************************************** */

const AddNotes = ( props ) => {

    const formActions = get( props.data, 'formActions', [] );
    const formFields = get( props.data, 'fields', '' );
            
    return (
        <Form
            fields={ fromPairs( map( formFields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
            isValid={false}
            mode={props.mode}
            onSubmit={( { values, isValid } ) => {
                if ( isValid ) {
                    props.onSubmitClick( {
                        ...values
                    } );
                }
            }}
        >
            {( { fields, values, isValid, errors, onChange, onSumbit } = {} ) => {

                return (
                    <form
                        onSubmit={onSumbit}
                        className='ui-csr-order-notes__body__form'
                    >
                        { /* fields */}
                        { map( fields, ( field ) => {

                            const fieldClassName = classnames( 'ui-csr-order-notes__body__form__field',
                                `ui-csr-order-notes__body__form__field--${field.name}`
                            );

                            return (
                                <field.view
                                    className= { fieldClassName }
                                    key={ field.name }
                                    name={ field.name }
                                    required={ field.required }
                                    placeholder={ field.placeholder }
                                    label={ field.title }
                                    onChange={ onChange }
                                    value={ values[ field.name ] }
                                    error={ errors[ field.name ] }
                                    maxLength={ field.maxLength }
                                    options={ props.data.options[ field.options ] }
                                    requestPayload={ props.requestPayload }
                                />
                            );
                        } )}

                        {/* button actions */}
                        <div className='ui-csr-order-notes__body__form__actions'>
                            { map( formActions, action => {
                                return (
                                    <Button
                                        key={action.name}
                                        id={action.name}
                                        type={ 'cancel' !== action.name ? 'submit' : 'button' }
                                        disabled={'cancel' !== action.name ? !isValid : false }
                                        {...action}
                                        outline={ 'cancel' === action.name ? true : false }
                                        size='large'
                                        className='ui-csr-order-notes__body__form__actions__action'
                                        onClick={ isEqual( 'cancel', action.name ) ? () => {

                                            // props.onCancelClick();
                                            
                                            props.onAddClick( false );
                                        } : null }
                                    />
                                );
                            } ) }
                        </div>
                    </form>
                );
            }}
        </Form>
    );
};


export const cSrOrderListNotesSuccess = ( props ) => {
    
    const {  title, widgets } = props.data;

    // const { actions } = props.componentData;

    return (
        <div className='ui-c-sr-order-list-notes'>
            <div className='ui-c-sr-order-list-notes__header'>

                {/* title for the modal */}
                <div className='ui-c-sr-order-list-notes__header__title'>
                    { getLabel( title ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>
            </div>

            { ! props.enableAdd ? (
                <div className='ui-c-sr-order-list-notes__body'>
                    <div className='ui-c-sr-order-list-notes__body__table'>
                        <WidgetsTabFlow
                            tabs={ widgets }
                            theme='plain'
                            requestPayload={ props.requestPayload }
                            onCancelClick={ props.onCancelClick }
                            onAddClick={ props.onAddClick }
                        />
                    </div>
                    
                </div>
            ) : (
                <div className='ui-c-sr-order-list-notes__body'>
                    <AddNotes  { ...props } />
                </div>
            ) }
           
        </div>
    );
};


// set display name
cSrOrderListNotesSuccess.displayName = 'cSrOrderListNotesSuccess';


// set default props
cSrOrderListNotesSuccess.defaultProps = {
    componentData: {},
    layoutConfig: {},
    onActionClick: noop,
};

// prop types
cSrOrderListNotesSuccess.propTypes = {};

/*******************************/

// preloader view
export const cSrOrderListNotesPreloader = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-c-sr-order-notes-preloader', props.className );

    return (
        <div className={widgetClassName}>
            loading...
        </div>
    );
};

// set display name
cSrOrderListNotesPreloader.displayName = 'cSrOrderListNotesPreloader';

// set default props
cSrOrderListNotesPreloader.defaultProps = {};

// prop types
cSrOrderListNotesPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { cSrOrderListNotes as cSrOrderListNotes } from 'ui/views/widgets/cSrOrderListNotes';
 *
 * // render
 * <cSrOrderListNotes propName='propValue'/>
 */
export const cSrOrderListNotes = withNetworkState( cSrOrderListNotesPreloader, cSrOrderListNotesSuccess );
